import PropTypes from 'prop-types'
import React from 'react'
import { Row, Col } from 'reactstrap'

const propTypes = {
  scraperProductImages: PropTypes.array
}

const defaultProps = {
  scraperProductImages: []
}

/**
 * Presenting Scraper Product Detail Information
 */
const ScraperProductImageCard = ({ scraperProductImages }) => (
  <Row>
    {
      scraperProductImages.map((image, index) => <Row key={ `image-${index}` }>
        <Col lg='12' className='mr-3'>
          <Row>
            <Col lg='3'>
              {
                image.s3_product_list_url ?
                  <>
                    <img
                      src={ `${image.s3_product_list_url}` }
                      style={{ width: '200px', height: '200px' }}
                      alt=''
                    />
                    <h4
                      className='text-center'
                      style={{ width: '200px', height: 'auto' }}
                    >
                      { `${index + 1}` }
                    </h4>
                  </>
                  :
                  <>
                    <h4
                      className='text-center'
                      style={{ width: '200px', height: 'auto' }}
                    >
                      { 'Image' }
                    </h4>
                    <h4
                      className='text-center'
                      style={{ width: '200px', height: 'auto' }}
                    >
                      { `${index + 1}` }
                    </h4>
                  </>
              }
            </Col>
          </Row>
        </Col>
      </Row>
      )
    }
  </Row>
)

ScraperProductImageCard.defaultProps = defaultProps
ScraperProductImageCard.propTypes    = propTypes

export default ScraperProductImageCard
